import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#9b004b',
        secondary: '#424242',
        accent: '#6E6E6E',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        main: '#FFFFFF'
      }
      // TODO Add Dark theme
    }
  },
  customVariables: ['../scss/_variables.scss'],
  breakpoint: {
    thresholds: {
      xs: 600,
      sm: 1024,
      md: 1280,
      lg: 1920
    },
  },
  icons: {
    iconfont: 'mdi'
  }
});
